export const LOAD_MENU = 'OPERATIONS/LOAD_MENU';
export const LOAD_MENU_SUCCESS = 'OPERATIONS/LOAD_MENU_SUCCESS';
export const LOAD_MENU_ERROR = 'OPERATIONS/LOAD_MENU_ERROR';

export const LOAD_OPERATIONS = 'OPERATIONS/LOAD_OPERATIONS';
export const LOAD_OPERATIONS_SUCCESS = 'OPERATIONS/LOAD_OPERATIONS_SUCCESS';
export const LOAD_OPERATIONS_ERROR = 'OPERATIONS/LOAD_OPERATIONS_ERROR';

export const UPDATE_OPERATIONS_FILTERS = 'OPERATIONS/UPDATE_OPERATIONS_FILTERS';
export const SET_OPERATIONS_PAGE_SELECTED = 'OPERATIONS/SET_OPERATIONS_PAGE_SELECTED';
